import styled from "styled-components/macro";

export const StyledOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 2200;
  pointer-events: none;
`;

export const StyledContainer = styled.div`
  pointer-events: auto;
  background-color: var(--menu-color);
  box-shadow: var(--default-drop-shadow);
  border-radius: 17px;
  padding: 20px 17px 22px 15px;
  color: var(--grey-0);
  max-width: 280px;
  min-height: 120px;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: center;
  outline: none;

  p {
    font-weight: 500;
    font-size: 16px;
    font-family: Inter;
    font-style: normal;
    line-height: normal !important;

    &.heading {
      font-weight: 700;
      margin-bottom: 10px;
    }

    &.countdown-heading {
      text-align: center;
      padding-top: 5px;
    }

    &.countdown-num {
      text-align: center;
      font-weight: 700;
      font-size: 65px;
    }
  }
  .text-content {
    display: flex;
    flex-direction: column;
    gap: 10px;

  }
  .choices {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
    margin-top: 26px;
    margin-left: -6px;
    margin-bottom: -6px;

    &.final {
      justify-content: center;
      margin-top: 18px;
    }

    .confirm {
      .text-button-inner {
        color: var(--danger-color) !important;
      }
    }

    button.link-style {
      border: none !important;
      background: none !important;
      padding: 0 !important;
      margin: 0 !important;
      color: var(--grey-0) !important;

      &.final-cancel {
        border-bottom: 1px solid var(--grey-0) !important;
        border-radius: 0 !important;
      }

      &:hover {
        font-weight: 700 !important;
      }
    }
  }
`;
